import React, { useState } from 'react'
import '../../Assets/Css/AddProject.scss'
import { customStyle } from '../../Components/Style'
import Select from 'react-select'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { getShareholdersList } from '../../Services/Shareholders/action'
import { connect } from 'react-redux'
import { addClient, updateClients } from '../../Services/Clients/action'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import DatePicker from 'react-datepicker';
import { FaUserCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";

const initialState = {
    title: null,
    givenTo: null,
    projectstatus: null,
    currency: null,
    addedby: null,
    name: '',
    notes: '',
    clientInvoices: []
}

const ProjectCategory = [
    { value: 'Design', label: 'Design' },
    { value: 'Development', label: 'Development' },
    { value: 'Research And Development', label: 'Research And Development' },
];

const Department = [
    { value: "Intern", label: "Intern" },
    { value: "Design", label: "Design" },
    { value: "Development", label: "Development" },
    { value: "FullStack", label: "FullStack" },
    { value: "Frontend", label: "Frontend" },
    { value: "Backend", label: "Backend" },
    { value: "HR", label: "HR" },
];

const Currency = [
    { value: "₹ (INR)", label: "₹ (INR)" },
    { value: "¥ (JPY)", label: "¥ (JPY)" },
    { value: "£ (GBP)", label: "£ (GBP)" },
    { value: "$ (USD)", label: "$ (USD)" },
    { value: "$ (CAD)", label: "$ (CAD)" },
];

const ProjectAssignedTo = [
    { value: "Kuntesh Kothiya", label: "Kuntesh Kothiya" },
    { value: "Divisha Makwana", label: "Divisha Makwana" },
    { value: "Harsh Patel", label: "Harsh Patel" },
    { value: "Hinali Narola", label: "Hinali Narola" },
    { value: "Janvi Thummar", label: "Janvi Thummar" },
    { value: "Jatin Tiwari", label: "Jatin Tiwari" },
    { value: "Meet Ghanva", label: "Meet Ghanva" },
    { value: "Nand Vachani", label: "Nand Vachani" },
    { value: "Raj Viradiya", label: "Raj Viradiya" },
];

const AddedBy = [
    { value: "Kuntesh Kothiya", label: "Kuntesh Kothiya" },
    { value: "Divisha Makwana", label: "Divisha Makwana" },
    { value: "Harsh Patel", label: "Harsh Patel" },
    { value: "Hinali Narola", label: "Hinali Narola" },
    { value: "Janvi Thummar", label: "Janvi Thummar" },
    { value: "Jatin Tiwari", label: "Jatin Tiwari" },
    { value: "Meet Ghanva", label: "Meet Ghanva" },
    { value: "Nand Vachani", label: "Nand Vachani" },
    { value: "Raj Viradiya", label: "Raj Viradiya" },
];

const ProjectStatus = [
    { value: 'In_Progress', label: 'In Progress', color: '#00B5FF' },
    { value: 'Not_Started', label: 'Not Started', color: 'gray' },
    { value: 'On_Hold', label: 'On Hold', color: '#F5C308' },
    { value: 'Cancelled', label: 'Cancelled', color: '#D21010' },
    { value: 'Finished', label: 'Finished', color: '#679C0D' }
];

const OptionRenderer = ({ data }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaUserCircle
                style={{
                    width: '20px',
                    height: '20px',
                    color: '#ced4da',
                    marginRight: '10px'
                }}
            />
            <span>{data.label}</span>
        </div>
    );
};

const AddEditProject = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location?.state?.data;
    const [clientData, setClientData] = useState(initialState);
    const [isUpdate, setIsUpdate] = useState(false);
    const [deletedInvoices, setDeletedInvoices] = useState([]);
    const [updateInvoices, setUpdateInvoices] = useState([]);
    const [progress, setProgress] = useState(0);
    const [showDetails, setShowDetails] = useState(false);

    const toggleDetails = () => {
        setShowDetails(prev => !prev);
    };

    const handleRangeChange = (event) => {
        setProgress(event.target.value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value
        }))
    }

    const handleSubmit = async () => {
        try {
            if (isEmptyField()) {
                return;
            }
            if (isUpdate) {
                let { managed_by, clientInvoices, ...inputData } = clientData;
                const newInvoice = updateInvoices?.map(items => ({ id: items.value, client_id: data?.ClientId?.value }));
                let deletedInvoicesList = deletedInvoices.filter(item => item.deletedAt).map(items => ({ id: items.value, client_id: null }));

                const putData = {
                    ...inputData,
                    managed_by: clientData.managed_by.value,
                    title: clientData.title.value,
                    clientInvoices: [...newInvoice, ...deletedInvoicesList],
                    id: data?.ClientId?.value
                }
                await props.updateClients(data?.ClientId?.value, putData);
            } else {
                const postData = {
                    ...clientData,
                    managed_by: clientData.managed_by.value,
                    title: clientData.title.value,
                    clientInvoices: clientData.clientInvoices.map((item) => ({ id: item.value }))
                }
                await props.addClient(postData);
                setClientData(initialState);
            }
        } catch (error) {
            toast.error(error);
        }
        navigate("/employees/view/project")
    }

    return (
        <div className="addUpdateClient-main">
            <div className="page-title">
                <h4> {location.pathname === "/project/add" ? "Add" : "Update"} Project</h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >
                        {props.loading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            "Cancel"
                        )}
                    </button>

                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >
                        {props.loading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            "Save"
                        )}
                    </button>
                </div>
            </div>

            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part p-4">
                            <div className="custom-row">
                                <div className="add-project-detail">
                                    {/* <h5 className='project-detail-divider'> Project Details </h5> */}
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Short Code *</h6>
                                                <input type="text" className="input-css" name='shortcode' disabled={props.loading} value={clientData.country} placeholder="Project unique short code" onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <h6 className='label'>Project Name *</h6>
                                                <input type="text" className="input-css" name='projectname' disabled={props.loading} value={clientData.country} placeholder='Write a project name' onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Start Date *</h6>
                                                {/* <CustomCalendar /> */}
                                                <DatePicker
                                                    styles={customStyle}
                                                    selected={clientData.name ? new Date(clientData.name) : null}
                                                    placeholderText="Select Date"
                                                    onChange={(date) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            name: date.toISOString().split('T')[0],
                                                        }));
                                                    }}
                                                    dateFormat="dd-MM-yyyy"
                                                    name="transaction_date"
                                                    disabled={props.loading}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Deadline *</h6>
                                                {/* <CustomCalendar /> */}
                                                <DatePicker
                                                    styles={customStyle}
                                                    selected={clientData.name ? new Date(clientData.name) : null}
                                                    placeholderText="Select Date"
                                                    onChange={(date) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            name: date.toISOString().split('T')[0],
                                                        }));
                                                    }}
                                                    dateFormat="dd-MM-yyyy"
                                                    name="transaction_date"
                                                    disabled={props.loading}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-sm-6 due_date_radio">
                                            <div className="radiobtn">
                                                <input type="checkbox" />
                                                <lable className="label">There is no project deadline</lable>
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Project Category</h6>
                                                <Select
                                                    options={ProjectCategory}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                        }),
                                                    }}
                                                    value={clientData.title}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            title: val
                                                        }))
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Department</h6>
                                                <Select
                                                    options={Department}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                        }),
                                                    }}
                                                    value={clientData.givenTo}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            givenTo: val
                                                        }))
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Client</h6>
                                                <input
                                                    type="text"
                                                    className="input-css"
                                                    name='projectname'
                                                    disabled={props.loading}
                                                    value={clientData.country}
                                                    placeholder="---"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-9">
                                            <div className="input-group">
                                                <h6 className='label'>Assigned To</h6>
                                                <Select
                                                    options={ProjectAssignedTo}
                                                    getOptionLabel={option => <OptionRenderer data={option} />}
                                                    getOptionValue={option => option.value}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                            width: '100%',
                                                        }),
                                                        control: (provided) => ({
                                                            ...provided,
                                                            boxShadow: 'none',
                                                            border: '1px solid #ced4da',
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: '#6c757d',
                                                        }),

                                                    }}
                                                    value={clientData.givenTo}
                                                    placeholder="---"
                                                    onChange={(selectedOptions) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            givenTo: selectedOptions
                                                        }));
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                    isSearchable
                                                    isMulti
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Project Status</h6>
                                                <Select
                                                    options={ProjectStatus}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                            width: '100%',
                                                        }),
                                                        control: (provided) => ({
                                                            ...provided,
                                                            boxShadow: 'none',
                                                            border: '1px solid #ced4da',
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: '#6c757d',
                                                        }),
                                                    }}
                                                    value={clientData.projectstatus}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            projectstatus: val
                                                        }));
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                    isSearchable
                                                    getOptionLabel={(e) => (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span
                                                                style={{
                                                                    height: '12px',
                                                                    width: '12px',
                                                                    backgroundColor: e.color,
                                                                    borderRadius: '50%',
                                                                    display: 'inline-block',
                                                                    marginRight: '10px',
                                                                    marginLeft: '10px'
                                                                }}
                                                            />
                                                            {e.label}
                                                        </div>
                                                    )}
                                                    getOptionValue={(e) => e.value}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Project Completion Status</h6>
                                                <input
                                                    type="range"
                                                    className="form-range"
                                                    id="customRange1"
                                                    min="0"
                                                    max="100"
                                                    value={progress}
                                                    onChange={handleRangeChange}
                                                    style={{ marginBottom: "-15px" }}
                                                />
                                                {progress}%
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-sm-6 due_date_radio">
                                            <div className="radiobtn">
                                                <input type="checkbox" />
                                                <lable className="label">Calculate progess through tasks</lable>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="note-part">
                                                <h6 className="label">Project Summary</h6>
                                                <div className="editor-custom">
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        // data={clientData.notes}
                                                        onReady={editor => {
                                                            console.log('Editor is ready to use!', editor);
                                                        }}
                                                        onChange={(event, editor) => {
                                                            const data = editor.getData();
                                                            console.log({ event, editor, data });
                                                            setClientData((preVal) => ({
                                                                ...preVal,
                                                                notes: data
                                                            }))
                                                        }}
                                                        onBlur={(event, editor) => {
                                                            console.log('Blur.', editor);
                                                        }}
                                                        onFocus={(event, editor) => {
                                                            console.log('Focus.', editor);
                                                        }}
                                                    />
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                    <h5 className='other-detail-divider' onClick={toggleDetails} style={{ cursor: 'pointer' }}>
                                        Other Details
                                        <span style={{ cursor: 'pointer', marginLeft: '5px', fontSize: '30px' }}>
                                            {showDetails ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                        </span>
                                    </h5>
                                    {showDetails && (
                                        <div className="row">

                                            <div className="col-lg-4">
                                                <div className="input-group">
                                                    <h6 className='label'>Currency</h6>
                                                    <Select
                                                        options={Currency}
                                                        styles={{
                                                            ...customStyle,
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 2,
                                                            }),
                                                        }}
                                                        value={clientData.currency}
                                                        placeholder="---"
                                                        onChange={(val) => {
                                                            setClientData((preVal) => ({
                                                                ...preVal,
                                                                currency: val
                                                            }))
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="input-group">
                                                    <h6 className='label'>Project Budget</h6>
                                                    <input type="text" className="input-css" name='projectbudget' disabled={props.loading} value={clientData.country} placeholder="e.g. 10000" onChange={handleChange} />
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="input-group">
                                                    <h6 className='label'>Hours Estimate (In Hours)</h6>
                                                    <input type="text" className="input-css" name='hoursestimate' disabled={props.loading} value={clientData.country} placeholder="e.g. 500" onChange={handleChange} />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-6">
                                                <div className="radiobtn">
                                                    <input type="checkbox" />
                                                    <lable className="label">Allow Mannual time logs</lable>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-6">
                                                <div className="radiobtn">
                                                    <input type="checkbox" />
                                                    <lable className="label">Send task notification to client</lable>
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="input-group">
                                                    <h6 className='label'>Added By</h6>
                                                    <Select
                                                        options={AddedBy}
                                                        getOptionLabel={option => <OptionRenderer data={option} />}
                                                        styles={{
                                                            ...customStyle,
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 2,
                                                                width: '100%',
                                                            }),
                                                            control: (provided) => ({
                                                                ...provided,
                                                                boxShadow: 'none',
                                                                border: '1px solid #ced4da',
                                                            }),
                                                            placeholder: (provided) => ({
                                                                ...provided,
                                                                color: '#6c757d',
                                                            }),
                                                        }}
                                                        value={clientData.addedby}
                                                        placeholder="---"
                                                        onChange={(val) => {
                                                            setClientData((preVal) => ({
                                                                ...preVal,
                                                                addedby: val
                                                            }));
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                        isSearchable
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-4 col-sm-6">
                                                <div className="radiobtn">
                                                    <input type="checkbox" />
                                                    <lable className="label">Enable Miroboard</lable>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        loading: state.clientsReducer.loading,
        shareholdersList: state.shareholdersReducer.shareholderslist,
        invoicesList: state.invoicesReducer.invoiceslist,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getShareholdersList: () => {
            dispatch(getShareholdersList());
        },
        getInvoicesList: () => {
            dispatch(getInvoicesList());
        },
        addClient: (data) => {
            dispatch(addClient(data))
        },
        updateClients: (id, data) => {
            dispatch(updateClients(id, data))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddEditProject);